
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_2496k_145",
  "slider-side": "awsui_slider-side_cqzlk_2496k_179"
};
  